export default [
    {
        title: 'How to Take a Good Picture',
        id:0,
        imageUrl:'https://images.unsplash.com/photo-1568198473832-b6b0f46328c1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=992&q=80',
        summary: 'There are a few simple tricks to taking a good picture; light, composition, and...',
        alt:'Photo by 郭 心 宇 on Unsplash https://unsplash.com/@viagalactica',
    },

    {
        title:'How to Build a Table',
        id:1,
        imageUrl:'https://images.unsplash.com/photo-1547609434-b732edfee020?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1927&q=80',
        summary:'Building your own furniture is a satisfying experience and a fun project to share with your family...',
        alt: 'Photo by Andrew Ruiz on Unsplash https://unsplash.com/photos/@andrewruiz'
    },

    {
        title: 'How to Do a Backbend Safely',
        id:2,
        imageUrl:'https://images.unsplash.com/photo-1552196527-bffef41ef674?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=926&q=80',
        summary: 'If you\'re ready to go beyond beginner yoga and into more challenging poses, there are several backbend poses that...',
        alt: 'Photo by Dane Wetton on Unsplash https://unsplash.com/photos/@dane_ew'
    },

    {
        title:'How to Stay Hydrated on Long Distance Bike Rides',
        id:3,
        imageUrl:'https://images.unsplash.com/photo-1558415737-d2d14ef33023?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80',
        summary:'Staying hydrated on the trail can make all the difference between a successful long-distance ride and a...',
        alt: 'Photo by Victor Xok on Unsplash https://unsplash.com/photos/@xokvictor'
    },

    {
        title:'How to Change a Tire in 5 Steps',
        id:4,
        imageUrl:'https://images.unsplash.com/photo-1559219582-54efb8aba261?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1051&q=80',
        summary:'You don\'t have to wait for a tow truck when you can do the job yourself. In five easy steps, here is how you can...',
        alt: 'Photo by Petr Urbanek on Unsplash https://unsplash.com/photos/@r4o4'
    },


    {
        title: 'How to Trim Your Cat\'s Nails',
        id:5,
        imageUrl:'https://images.unsplash.com/photo-1494256997604-768d1f608cac?ixlib=rb-1.2.1&auto=format&fit=crop&w=1101&q=80',
        summary:'Most cats do not enjoy having their paws handled, let alone their nails trimmed, but here are a few ways to make the process better...',
        alt: 'Photo by Mikhail Vasilyev on Unsplash https://unsplash.com/photos/@miklevasilyev'
        
    },

  
];
